export const getImageIdFromUrl = (url: string): string => {
  const array = url.split('/');
  const imageName = array.pop();
  const path = array.pop();
  return `VisCart-${path}/${imageName}`;
};
